export enum AnalyticsChartColors {
	Coral = '#E8684A',
	Teal = '#4DB89A',
	Yellow = '#C4B84D',
	Sky = '#5BA3C8',
	SeaGreen = '#4A9D6E',
	Grey = '#9CA3AF',
}

export const AnalyticsChartColorsArray = [
	AnalyticsChartColors.Coral,
	AnalyticsChartColors.Teal,
	AnalyticsChartColors.Yellow,
	AnalyticsChartColors.Sky,
	AnalyticsChartColors.SeaGreen,
];
